import Story from './Story/Story';

export default Story;